
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  if(Flits.request.page_type == "customers/register"){
    if(window.flitsObjects.allCssJs.libphoneNumberJs){
      Flits.LoadStyleScript('libphoneNumberJs',window.flitsObjects.allCssJs.libphoneNumberJs.url);
    }
  }
  if(location.pathname.indexOf("/account/register") == 0) {
      Flits.setLocalStorage('flits_last_visited_url', '/account/register');
  }
  setTimeout(function() {
      if(location.pathname.indexOf("/account") == -1) {
          Flits.setLocalStorage('flits_before_login_url', '/account');
      }
  }, 800);
Flits(window).load(function() {
  if(location.pathname.indexOf("/account") == -1) {
      if(location.pathname.indexOf("checkout") != -1) {
          Flits.setLocalStorage('flits_before_login_url', location.pathname);
      } else {
          Flits.setLocalStorage('flits_before_login_url', '/account');
      }
  }
});  
let phone,gender,birthday,customer_note;
Flits(document).on('Flits:AccountPage:Loaded', function(event){
   setInterval(function(){
     var data = event.detail;
     Flits.shopCountryName = 'Hong Kong';
   },1000);
});
if (Flits.customer_id != -1) {
  let customer_note_url = Flits.base_url+'/'+Flits.customer_id + "/get_customer_shopify_data";
  Flits.ajax({
    method: "get",
    url: customer_note_url,
    data: {
      token: Flits.token,
      customer_hash: Flits.customerHash
    },
  }).done(function(resp){ 
    if (resp.status) {
      console.log(resp.customer.note.split('\n'));
      customer_note = resp.customer.note.split('\n');
    }
  }).fail(function(resp){
  
  }).always(function(){});  
  
}
  
function flitsRemovePrefix(inputString) {
  // Replace '+852' or '852' at the beginning of the string with an empty string
  return inputString.replace(/^(\+852|852)\s*/, '');
}
function contact_function(){
  setTimeout(function() {
    Flits(".flits-profile-save-button").click();
    Flits(".flits-snackbar-container").css('opacity', '1'); 
  }, 500);
  Flits(document).on('Flits:myProfile:Updated', (function() {
    Flits(".flits-profile-div #flits-form-profile").css("visibility","visible");
    Flits(".flits-snackbar-container").css('opacity', '0');
    setTimeout(function() {
      Flits(".flits-snackbar-container").css('opacity', '0');
    }, 200);
    setTimeout(function() {
      Flits(".flits-snackbar-container").css('opacity', '0');
    }, 500);
  }));
  setTimeout(function() {
    Flits(".flits-snackbar-overlay").css('opacity', '1');
  }, 3000);
  Flits(".flits-profile-edit-button").click();
  Flits(".flits-profile-div #flits-form-profile").css("visibility","visible");
}
  
Flits(document).on("Flits:myProfile:Loaded",(function(){
  var customurl = Flits.getLocalStorage('flits_last_visited_url');
  if (customurl == '/account/register') {
    for (let i = 0; i < customer_note.length; i++) {
      if (customer_note[i].trim().indexOf('phone') == 0) {
        phone = customer_note[i].trim().replace('phone:','');
      }
      if (customer_note[i].trim().indexOf('gender') == 0) {
        gender = customer_note[i].trim().replace('gender:','');
      }
      if (customer_note[i].trim().indexOf('birthday') == 0) {
        birthday = customer_note[i].trim().replace('birthday:','');
      }
    }
    setTimeout(function(){
      if(Flits('.flits-phone-with-country-div .flits-input-wrap input[name="phone"]').val() == '' || Flits('input[name="birthdate"]').val() == '' ){
            var custom_contact = phone.trim();
            if(custom_contact){
              
              if(custom_contact.indexOf('+852') !== -1 || custom_contact.indexOf('852') !== -1){
                custom_contact = flitsRemovePrefix(custom_contact)
              }
              Flits('.flits-phone-with-country-div .flits-input-wrap input[name="phone"]').val("+852" + custom_contact);
            }
            if (Flits('input[name="birthdate"]').val() == '') {
              console.log(birthday);
              Flits('input[name="birthdate"]').val(birthday.trim());
            }
            if (Flits('[name="gender"]').val() == 'none' || Flits('[name="gender"]').val() == '') {
              console.log(gender);
              // Flits(`[name="gender"] option[value="${gender.trim().toLowerCase()}"]`).prop('selected','selected');
              Flits(`[name="gender"] option[value="${gender.trim().toLowerCase()}"]`).prop('selected','selected');
            }
            if ('.flits-phone-with-country-div .flits-input-wrap input[name="phone"]' != '' ||  Flits('input[name="birthdate"]').val() != '') {
              contact_function();
            }
            // Flits(".flits-profile-div #flits-form-profile").css("visibility","initial");
      }
      else{
        // Flits(".flits-profile-div #flits-form-profile").css("visibility","initial");
      }
    }, 1000);
  }else{
      Flits(".flits-profile-div #flits-form-profile").css("visibility","initial");
  }
}));
Flits(document).on('Flits:myProfile:BeforeUpdate', function(event){
    if (Flits.getLocalStorage('flits_last_visited_url') != '/account/register') {
      var e_data =  event.detail.params;
      let new_data = [];
      let update_phone;
      let update_birthday;
      let update_gender;
      for (let i = 0; i < e_data.length; i++) {
        switch (e_data[i].name){
            case 'gender':
                  update_gender = e_data[i].value;
                  break;
            case 'birthdate':
                  update_birthday = e_data[i].value;
                  break;
            case 'phone':
                  update_phone = e_data[i].value;
                  break;
        }
      }
        for (var i = 0; i < customer_note.length; i++) {
          var parts = customer_note[i].split(': ');
          if (parts[0] === 'phone') {
              parts[1] = update_phone;
          } else if (parts[0] === 'gender') {
              parts[1] = update_gender;
          } else if (parts[0] === 'birthday') {
              parts[1] = update_birthday;
          }
          customer_note[i] = parts.join(': ');
      }
      customer_note = customer_note.join('\n');
      e_data.push({"name":"customer_note","value":customer_note});
      
    }else{
      Flits.setLocalStorage('flits_last_visited_url', '');
        Flits(".flits-profile-div #flits-form-profile").css("visibility","visible");
    }
  })
 var numberValid = true;
  var validateNumberData;
Flits(document).on('click','#create_customer input[type="submit"]',function(e) {
  Flits('.error').remove();
  validateNumberData = Flits('input[name="customer[note][phone]"]').val().trim();
  
  if (validateNumberData == '') {
    displayError('phone_number','Please enter contact number')
    numberValid = false;
    return false;
  }else{
    if (validateNumberData.startsWith("852")) {
      validateNumberData = `+${validateNumberData}`;
    }else{
      validateNumberData = `+852${validateNumberData}`;
    }  
    if(!validatePhone(validateNumberData)){
        displayError('phone_number','Contact number is not valid')
        numberValid = false;
        return false
       }
    else{
      numberValid = true;
      }
  }
  if(!numberValid) {
  e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
  }
})
function validatePhone(data) {
    if(new libphonenumber.parsePhoneNumber(data).isValid()) {
        return true
    }
    return false
}
function displayError(element, errorMessage) {
  $(`#${element}`).after(`<div class="error" style="color:red;">${errorMessage}</div>`);
}
  
// if(window.location.pathname == '/account/register'){
// const phoneInput = document.getElementById('phone_number');
    
//   phoneInput.addEventListener("input", function () {
//     const phoneNumber = phoneInput.value.trim();

//     if (phoneNumber.startsWith("852")) {
//         // Allow up to 11 digits
//         if (/^\d{1,11}$/.test(phoneNumber)) {
//             phoneInput.value = phoneNumber.slice(0, 11);
//         } else {
//             phoneInput.value = phoneNumber.slice(0, 11); // Truncate to 11 digits
//         }
//     } else {
//         // Restrict to exactly 8 digits
//         if (/^\d{8}$/.test(phoneNumber)) {
//             phoneInput.value = phoneNumber;
//         } else {
//             phoneInput.value = phoneNumber.slice(0, 8); // Truncate to 8 digits
//         }
//     }
// });

//    }
}(Flits));
